import { FC, MouseEvent, ReactNode } from 'react'
import styled, { css } from 'styled-components'

export type TOptionsValue = {
  label: string
  value: string
  icon?: ReactNode
}

interface IFProps {
  options: Array<TOptionsValue>
  onClick: (value: TOptionsValue) => void
  className?: string
}

const SelectOption: FC<IFProps> = ({ options, onClick, className }) => {
  const handleClick = (e: MouseEvent<HTMLLIElement>) => {
    onClick({
      value: e.currentTarget.dataset.selectValue || '',
      label: e.currentTarget.dataset.selectLabel || '',
    })
  }

  return (
    <StyledWrapper className={className}>
      {options.map((option) => {
        return (
          <li
            key={`option-id-${option.value}`}
            onClick={handleClick}
            data-select-value={option.value}
            data-select-label={option.label}
          >
            {option.icon} <p>{option.label}</p>
          </li>
        )
      })}
    </StyledWrapper>
  )
}

export default SelectOption

const StyledWrapper = styled.ul`
  ${({ theme }) => css`
    width: 100%;
    height: fit-content;
    max-height: 320px;
    overflow-y: auto;
    border: solid 1px ${theme.line.line_1};
    border-radius: 8px;
    background-color: ${theme.background.bg_8};
    position: absolute;
    left: 0;
    top: 54px;
    z-index: 10;

    & > li {
      height: 40px;
      display: flex;
      align-items: center;
      padding: 10px 15px;

      &:hover {
        background-color: ${theme.background.bg_3};
      }

      p {
        height: 20px;
        font-size: 14px;
        font-weight: normal;
        line-height: 20px;
        letter-spacing: -0.56px;
        text-align: left;
        color: ${theme.color.text_1};

        &:not(:first-child) {
          margin-left: 5px;
        }
      }
    }
  `}
`
